import {Box, Divider, Drawer, Stack, Typography, useTheme} from "@mui/material";
import {FiHome, FiLock, FiLogOut, FiUsers, FiMonitor, FiSettings, FiKey, FiShield} from "react-icons/fi";
import logo from "../../assets/ts-logo.png";
import logo_blanc from "../../assets/ts-logo-blanco.png";
import useLogout from "../../hooks/useLogout";
import styles from "./Sidebar.module.css";
import MenuItem from "../MenuItem/MenuItem";
import {useAuthPermissions} from "../../hooks/useAuthPermissions";
import {useThemeStore} from "../../stores/useThemeStore";
import ThemeToggleSimple from "../ui/ThemeButton";

const Sidebar = () => {
  const {logout} = useLogout();
  const {verifyRole} = useAuthPermissions();
  const {isDark} = useThemeStore();

  const handleLogout = () => {
    logout();
  };

  const menuItems = [
    {text: "Dashboard", icon: <FiHome />, path: "/dashboard"},
    {text: "Usuarios", icon: <FiUsers />, path: "/users", roles: ["AUTH.Admin", "AUTH.User"]},
    {text: "Roles", icon: <FiLock />, path: "/roles", roles: ["AUTH.Admin"]},
    {text: "Clientes", icon: <FiMonitor />, path: "/clients", roles: ["AUTH.Admin"]},
    {text: "Scopes", icon: <FiSettings />, path: "/scopes", roles: ["AUTH.Admin"]},
    {text: "Tokens", icon: <FiKey />, path: "/tokens", roles: ["AUTH.Admin"]},
    {text: "M2M Tokens", icon: <FiShield />, path: "/m2m-tokens", roles: ["AUTH.Admin"]}
  ];

  const visibleMenuItems = menuItems.filter(({roles}) => !roles || verifyRole(roles));

  const theme = useTheme();

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: "250px",
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: "250px",
          backgroundColor: theme.palette.sidebar.background,
          borderRight: `1px solid ${theme.palette.sidebar.border}`,
          boxSizing: "border-box"
        }
      }}
    >
      <Box className={styles.container}>
        <Box className={styles.header}>
          <img src={isDark() ? logo_blanc : logo} alt="Logo" className={styles.logo} />
        </Box>
        <Box className={styles.title}>
          <Typography variant="sidebarTitle" fontWeight="bold" color={theme.palette.sidebar.title}>
            AUTH PANEL
          </Typography>
        </Box>
        <Stack direction="column" spacing={1} className={styles.menu}>
          {visibleMenuItems.map(({text, icon, path, onClick}) => (
            <MenuItem key={text} text={text} icon={icon} onClick={onClick} path={path} />
          ))}
        </Stack>
        <Box className={styles.footer}>
          {/* BOTÓN LIGHT / DARK */}
          <Box mb={1.5}>
            <ThemeToggleSimple />
          </Box>
          <Divider className={styles.divider} />
          <MenuItem key={"Salir"} text={"Salir"} icon={<FiLogOut color="#d53c65" />} onClick={handleLogout}></MenuItem>
        </Box>
      </Box>
    </Drawer>
  );
};

export default Sidebar;
